export default __webpack_public_path__ + "static/media/cont-about.39ca574a.webp";